export function maskNumber(input) {
  const numStr = input.toString();
  if (numStr.length <= 3) return numStr; // If number is too short, return as is
  const firstOne = numStr.slice(0, 1);
  const lastTwo = numStr.slice(-2);
  const middle = "X".repeat(numStr.length - 4);
  return `${firstOne}${middle}${lastTwo}`;
}

export function maskEmail(email) {
  const [localPart, domain] = email.split("@");

  if (!domain || localPart.length <= 2) {
    return email; // Not a valid email or too short to mask
  }

  const firstTwo = localPart.slice(0, 1);
  const lastChar = localPart.slice(-1);
  const middle = "X".repeat(localPart.length - 3);

  return `${firstTwo}${middle}${lastChar}@${domain}`;
}
